"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryWarningStore = void 0;
const api_1 = require("client/api");
const router_1 = require("client/components/router");
const mobx_1 = require("mobx");
class InventoryWarningStore {
    constructor() {
        this.loading = false;
        this.name = "";
        this.id = "";
        this.warningLabelOne = "";
        this.warningLabelTwo = "";
        this.warningLabelThree = "";
        this.warningLabelFour = "";
        this.warningLabelFive = "";
        this.warningLabelSix = "";
        this.getWarningLabels = async (inventoryId) => {
            // console.log("inside getwarninglabels inventory id is ", inventoryId);
            this.id = inventoryId;
            this.loading = true;
            const result = await api_1.InventoryEndpoint.getWarningLabels.apiCall(null, {
                inventoryId
            });
            if (api_1.isError(result)) {
                return false;
            }
            try {
                // console.log("result is ", result);
                const warnings = result.warningLabels[0];
                this.name = warnings.name;
                this.warningLabelOne = warnings.labelOne;
                this.warningLabelTwo = warnings.labelTwo;
                this.warningLabelThree = warnings.labelThree;
                this.warningLabelFour = warnings.labelFour;
                this.warningLabelFive = warnings.labelFive;
                this.warningLabelSix = warnings.labelSix;
            }
            catch (error) {
                router_1.RouteManager.transitionTo("/formulary");
            }
            this.loading = false;
        };
        this.saveWarningLabels = async () => {
            await api_1.InventoryEndpoint.saveWarninglabels.apiCall(null, {
                labels: {
                    inventoryId: this.id,
                    labelOne: this.warningLabelOne,
                    labelTwo: this.warningLabelTwo,
                    labelThree: this.warningLabelThree,
                    labelFour: this.warningLabelFour,
                    labelFive: this.warningLabelFive,
                    labelSix: this.warningLabelSix
                }
            });
        };
    }
}
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelOne", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelTwo", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelThree", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelFour", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelFive", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningStore.prototype, "warningLabelSix", void 0);
__decorate([
    mobx_1.action
], InventoryWarningStore.prototype, "getWarningLabels", void 0);
__decorate([
    mobx_1.action
], InventoryWarningStore.prototype, "saveWarningLabels", void 0);
exports.inventoryWarningStore = new InventoryWarningStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-warning-labels/warning-store.ts
// module id = 3506
// module chunks = 0